import {
  IonPage,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  IonBackButton,
} from '@ionic/react';
import { AppSectionHeader } from '../../components/ui/AppSectionHeader';
import { LeagueSearchContent } from '../components/LeagueSearchContent';

export const LeagueSearchPage = () => (
  <IonPage>
    <AppSectionHeader variant="main">
      <IonToolbar>
        <IonButtons slot="start">
          <IonBackButton defaultHref="/app/main/mis-ligas" />
        </IonButtons>
        <IonTitle className="ml-4">Buscar liga</IonTitle>
      </IonToolbar>
    </AppSectionHeader>
    <IonContent className="ion-padding">
      <LeagueSearchContent />
    </IonContent>
  </IonPage>
);
